import React from "react"

import Table from "../../../../../components/Table"
import AppContext from "../../../../../components/AppContext"
import { AttributeTypeGroup, AttributeTypeGroupUsage, Project } from "../../../../../api/types"
import RadioButton, { RadioButtonProps } from "../../../../../components/RadioButton"
import { GetApi } from "../../../../../api/api"

interface PropertySetsAssociationProps {
  featureCatalog: Project
  propertySets: AttributeTypeGroup[]
  associations: AttributeTypeGroupUsage
  atgId: number
  fccId: string
  selectedFeatureTypesFromProp: { [key: number]: boolean }
}

interface PropertySetsAssociationState {
  propertySetsExcludedEdit: AttributeTypeGroup[]
  checkedRadio: boolean
  selectedPropertySet: number
  selectedFeatureTypes: { [key: number]: boolean }
}

const getData = async (fccId: string, selectedPropertySet: number) => {
  try {
    const api = await GetApi()
    // const associationSelectedPropertySet = await Promise.all([api.getAttributeTypeGroupAssociations(props.featureCatalog, props.selectedPropertySet]))

    return api.getAttributeTypeGroupAssociations(fccId, selectedPropertySet)
  } catch (error) {
    throw new Error(error as any)
  }
}

class PropertySetsAssociation extends React.Component<PropertySetsAssociationProps, PropertySetsAssociationState> {
  public static contextType = AppContext

  constructor(props: PropertySetsAssociationProps) {
    super(props)

    const excluded = this.props.propertySets.filter((item) => item.id !== this.props.atgId)

    this.state = {
      checkedRadio: false,
      selectedPropertySet: -1,
      selectedFeatureTypes: [],
      propertySetsExcludedEdit: excluded
    }
  }

  public selectPropertySet = (propertySet: AttributeTypeGroup) => {
    return this.setState({
      checkedRadio: !this.state.checkedRadio,
      selectedPropertySet: propertySet.id
    })
  }

  public deSelectPropertySet = () => {
    return this.setState({
      checkedRadio: !this.state.checkedRadio,
      selectedPropertySet: -1
    })
  }

  public render() {
    const rowData = this.state.propertySetsExcludedEdit.map((ps) => {
      return {
        iconProps: this.getRadioButtonProps(ps),
        name: ps.name
      }
    })

    const columnData = [
      {
        Header: "",
        accessor: "iconProps",
        width: 70,
        sortable: false,
        aggregate: (vals: RadioButtonProps) => {},
        Cell: (row: any) => {
          const value = row.value as RadioButtonProps
          return (
            <span className="d-flex justify-content-center">
              <RadioButton selected={value.selected} onToggle={value.onToggle} />
            </span>
          )
        }
      },
      {
        Header: "Property Sets",
        accessor: "name"
      }
    ]

    return <Table data={rowData} columns={columnData} />
  }

  private getRadioButtonProps(propertySet: AttributeTypeGroup) {
    return {
      selected: this.isPropertySetSelected(propertySet),
      onToggle: (e: any) => {
        this.isPropertySetSelected(propertySet) ? this.onUnSelectPropertySet() : this.onSelectPropertySet(propertySet)
      }
    }
  }

  private isPropertySetSelected(propertySet: AttributeTypeGroup) {
    return this.state.selectedPropertySet !== -1 && this.state.selectedPropertySet === propertySet.id
  }

  private onUnSelectPropertySet() {
    this.deSelectPropertySet()
  }

  private async onSelectPropertySet(propertySet: AttributeTypeGroup) {
    this.selectPropertySet(propertySet)

    const associationsFeatureType = await getData(this.props.fccId, propertySet.id).then((response) => response)

    const selectedFeatureTypesArray = (associationsFeatureType.featureTypeReferences || []).map(
      (ftr) => ftr.featureTypeId
    )

    const getSelectedSet = (idArray: number[]) => idArray.reduce((p, n) => ({ ...p, [n]: true }), {})

    this.setState(
      () => ({
        selectedFeatureTypes: {
          ...this.props.selectedFeatureTypesFromProp,
          ...getSelectedSet(selectedFeatureTypesArray)
        }
      }),
      () => this.onApplyAssociation()
    )
  }

  private setToIdArray = (set: { [key: number]: boolean }) => Object.keys(set).map(this.parseIds).filter(this.validId)

  private parseIds = (id: string) => {
    const numId = parseInt(id, 10)
    if (numId === null) {
      console.error("parseInt failed for id: ", id)
      return -1
    } else {
      return numId
    }
  }

  private validId = (id: number) => id !== -1

  private onApplyAssociation = () => {
    GetApi()
      .then((api) =>
        api.updateAttributeTypeGroupAssociation(this.props.fccId, this.props.atgId, {
          featureTypeIds: this.setToIdArray(this.state.selectedFeatureTypes)
        })
      )
      .catch((error) => this.context.useToasts.addToast(error, "danger"))
  }
}

export default PropertySetsAssociation
